import React, { memo, useEffect } from "react";
import PropTypes from "prop-types";
import { CommonUtils } from "utils";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";

const ConfirmDialog = ({
  title,
  content,
  submitProps: { submitText, isLoading, onClick: onSubmitClick, ...otherSubmitProps } = {},
  cancelProps: { cancelText, onClick: onCancelClick, ...otherCancelProps } = {},
  open,
  zIndex = 1070,
  ...otherProps
}) => {
  const { t: getLabel } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const handleKeyDown = e => {
      if (e.key === "Escape" && onCancelClick) {
        onCancelClick();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onCancelClick]);

  const primaryContent = CommonUtils.isString(content) ? (
    <p style={{ fontSize: "15px" }}>{content}</p>
  ) : (
    content
  );

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: zIndex - 5 }}></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog" style={{ zIndex }} {...otherProps}>
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content text-center" style={{ minWidth: "543px", padding: "12px 24px" }}>
            <div className="modal-header border-0 justify-content-center position-relative">
              <h5 className="modal-title fw-bold" style={{ fontSize: "20px" }}>{title || ""}</h5>
              <button
                type="button"
                className="btn-close position-absolute"
                style={{ right: 0, top: "50%", transform: "translateY(-50%)" }}
                aria-label="Close"
                onClick={onCancelClick}
              ></button>
            </div>
            <div className="modal-body pt-0">
              {primaryContent}
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-link link-secondary me-auto"
                onClick={onCancelClick}
                {...otherCancelProps}
              >
                {cancelText || getLabel(LangConstant.L_CANCEL)}
              </button>
              <button
                className="btn btn-primary"
                disabled={isLoading}
                onClick={onSubmitClick}
                {...otherSubmitProps}
              >
                {submitText || getLabel(LangConstant.L_DELETE_USER_BUTTON)}
                {isLoading && <span className="spinner-border spinner-border-sm ms-2"></span>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  submitProps: PropTypes.object,
  cancelProps: PropTypes.object,
};
ConfirmDialog.defaultProps = {
  submitProps: {},
  cancelProps: {},
};

export default memo(ConfirmDialog);
